var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVendorApproved = function SvgVendorApproved(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1456_7043)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.732422 8.00007C0.732422 3.9868 3.98582 0.733398 7.99909 0.733398C12.0124 0.733398 15.2658 3.9868 15.2658 8.00007C15.2658 12.0133 12.0124 15.2667 7.99909 15.2667C3.98582 15.2667 0.732422 12.0133 0.732422 8.00007ZM7.99909 1.9334C4.64856 1.9334 1.93242 4.64954 1.93242 8.00007C1.93242 11.3506 4.64856 14.0667 7.99909 14.0667C11.3496 14.0667 14.0658 11.3506 14.0658 8.00007C14.0658 4.64954 11.3496 1.9334 7.99909 1.9334ZM11.0341 5.52645C11.2957 5.7299 11.3428 6.10686 11.1394 6.36843L8.46803 9.803C8.01658 10.3834 7.1674 10.4588 6.62083 9.96685L4.93104 8.44604C4.68474 8.22437 4.66477 7.84499 4.88645 7.59869C5.10812 7.35238 5.48749 7.33241 5.7338 7.55409L7.42359 9.0749C7.45235 9.10079 7.49705 9.09682 7.52081 9.06627L10.1921 5.6317C10.3956 5.37013 10.7726 5.32301 11.0341 5.52645Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1456_7043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVendorApproved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "vendor-approved.52d5d90e2d5820c1ef4e4c97d99acfe5.svg";